import $ from 'jquery'

export default {
  init() {
    if (!$) {
      return;
    }

    var abp = abp || {};

    /* DEFAULTS *************************************************/

    abp.libs = abp.libs || {};
    abp.message = {}

    /* MESSAGE **************************************************/

    var showAbpMessage = function (type, message, title) {
      return null;
    };

    abp.message.info = function (message, title) {
      return showAbpMessage('info', message, title);
    };

    abp.message.success = function (message, title) {
      return showAbpMessage('success', message, title);
    };

    abp.message.warn = function (message, title) {
      return showAbpMessage('warn', message, title);
    };

    abp.message.error = function (message, title) {
      return showAbpMessage('error', message, title);
    };

    abp.message.confirm = function (message, titleOrCallback, callback) {
      return null;
    };

    window.abp.message = abp.message
  }
}



// WEBPACK FOOTER //
// ./scripts/services/Messages.js